import { VideoEdition } from './types';

const VIDEO_BASE = 'https://imagex1.sb-cd.com/gallery/videos/';
export const VIDEO_LINKS = {
    us: `${VIDEO_BASE}25/03/26/AV_intro_v1.mp4`,
    fr: `${VIDEO_BASE}25/04/07/june_v6.1_script_captioned_french.mp4`
};

export const DEFAULT_EDITION: VideoEdition = 'us';
